import { render, staticRenderFns } from "./MelonTVScheduleModal4Mobile.vue?vue&type=template&id=4dc6dc60&"
import script from "./MelonTVScheduleModal4Mobile.vue?vue&type=script&lang=js&"
export * from "./MelonTVScheduleModal4Mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports